import { memo, useMemo } from 'react';
import menuList from 'components/menu';
import { Box, Stack, Typography } from '@mui/material';
import AccountButton from 'components/admin/account/AccountButton';
import menuListByManager from 'components/manager/menu';
import { useProject } from 'hooks/useProject';
import MenuGroup from './MenuGroup';
import ProfileImage from './ProfileImage';

function MenuBox(): JSX.Element {
  const { getAdminAccountProfile } = useProject();
  const { data, isLoading } = getAdminAccountProfile();

  const menuListByType = useMemo(
    () => (!isLoading && data?.roles?.some(obj => obj.id === 10) ? menuList : menuListByManager),
    [data?.roles, isLoading],
  );
  const menuGroups = menuListByType.items.map(item => {
    switch (item.type) {
      case 'group':
        return <MenuGroup key={item.id} item={item} />;
      default:
        return null;
    }
  });
  return (
    <Box sx={theme => ({ pt: 0, height: '100vh', borderRight: `1px solid ${theme.palette.divider}` })}>
      <Stack
        direction="row"
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '1rem 1.5rem' }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <ProfileImage profileImg={null} />
          <Typography variant="s15w600">{data?.name || '-'}</Typography>
        </Stack>
        <AccountButton />
      </Stack>
      {menuGroups}
    </Box>
  );
}

export default memo(MenuBox);
